module.exports = __webpack_public_path__ + "img/grinning_squinting_face_3d.cff1d0f5.png";